import React from "react";
import {
  FirstScallToFullScaleSection,
  LogoContainer,
  SlideContent,
  SlideTitle,
  StyledCol,
  SwiperDiv,
} from "./style";
import { GlobalContainer } from "../../../Global/layout";
import { StyledHeadingh2 } from "../../../Global/headings";
import theme from "../../../../theme";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination } from "swiper";
import { LineHeading } from "../../../LineHeading";
import { Row } from "antd";

const FirstScallToFullScale = ({ data }: any) => {
  return (
    <section className="light">
      <FirstScallToFullScaleSection>
        <GlobalContainer>
          <LineHeading title="" number="" color={theme.black} />
          <StyledHeadingh2
            color={theme.black}
            text={data?.brandsScaleHeading}
            style={{ textAlign: "center" }}
          />
          <LogoContainer data-aos="fade-up">
            <Row gutter={40}>
              {data?.brandsScaleLists?.map((item: any, index: number) => {
                return (
                  <StyledCol xs={24} sm={12} md={12} lg={6} xl={6} key={index}>
                    <img
                      src={item.brandsScaleListImage?.mediaItemUrl}
                      alt={item.brandsScaleListImage?.altText}
                    />
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.brandsScaleListContent,
                      }}
                    />
                  </StyledCol>
                );
              })}
            </Row>
          </LogoContainer>
        </GlobalContainer>

        <SwiperDiv style={{ display: "none" }}>
          <Swiper
            data-aos="fade-up"
            slidesPerView={"auto"}
            spaceBetween={30}
            pagination={{ el: ".my-custom-pagination-div", clickable: true }}
            modules={[Pagination]}
            className="mySwiper"
          >
            {data?.brandsScaleLists?.map((item: any, index: number) => {
              return (
                <SwiperSlide key={index}>
                  <SlideTitle>{item.brandsScaleListHeading}</SlideTitle>
                  <SlideContent
                    dangerouslySetInnerHTML={{
                      __html: item.brandsScaleListContent,
                    }}
                  />
                </SwiperSlide>
              );
            })}
            <div className="my-custom-pagination-div" />
          </Swiper>
        </SwiperDiv>
      </FirstScallToFullScaleSection>
    </section>
  );
};

export default FirstScallToFullScale;
